require('./removeBeneficiaryView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ actions
const beneficiariesActions = require('actions/beneficiaries');
// @ components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');
const RemoveBeneficiary = require('components/transfers/transfersAgenda/removeBeneficiary/removeBeneficiary');
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

class RemoveBeneficiaryView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { requestBeneficiaries } = this.props;
        requestBeneficiaries();
    }

    componentWillUnmount() {
        const { setRemoveDefaultValues } = this.props;
        setRemoveDefaultValues();
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('breadcrumb-agenda'),
                url: '/myprofile/transfers/agenda' //TODO: check this
            },
            {
                text: formatText('transfersAgenda-removeBeneficiaryHeaderTitle'),
                url: ''
            }
        ];

        return (
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="transfers" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('transfersAgenda-removeBeneficiaryHeaderTitle')} />
                    </OKCover>
                </div>
            </div>
        );
    }

    render() {
        const { match: { params: { beneficiaryId } }, immBeneficiaries, requestRemoveBeneficiary } = this.props;
        const immBeneficiary = immBeneficiaries.get('byId').get(beneficiaryId);

        if (immBeneficiary) {
            const header = this.buildHeader();
            return (
                <section id="printable-wizard">
                    <div className="remove-beneficiary-view__title">
                        {header}
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid grid-view--content-position-negative">
                            <RemoveBeneficiary
                                requestRemoveBeneficiary={requestRemoveBeneficiary}
                                immBeneficiary={immBeneficiary}
                                immBeneficiaries={immBeneficiaries}
                            />
                        </div>
                    </div>
                </section>
            );
        }
        return <LoadingSection />;
    }
}

RemoveBeneficiaryView.propTypes = {
    requestBeneficiaries: PropTypes.func.isRequired,
    requestRemoveBeneficiary: PropTypes.func.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setRemoveDefaultValues: PropTypes.func.isRequired
};

module.exports.constructor = RemoveBeneficiaryView;
module.exports.RemoveBeneficiaryView = connect(
    state => ({
        immBeneficiaries: state.beneficiaries
    }), {
    requestBeneficiaries: beneficiariesActions.requestBeneficiaries,
    requestRemoveBeneficiary: beneficiariesActions.requestRemoveBeneficiary,
    setRemoveDefaultValues: beneficiariesActions.setRemoveDefaultValues
})(RemoveBeneficiaryView);
